<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>SAION - Tecnología gubernamental</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i" rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>



<footer id="footer" style="background-color: #126d17;">





  <div class="footer-top" style="background-color: #ffffff;">
    <div class="container">
      <div class="row">




        <div class="col-lg-3 col-md-6 footer-contact">
          <h3 style="color: #0a680a;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">CONTACTO</h3>
          <p style="color: #0a680a;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">
            Carranza Silva No. 1, Casimiro Castillo<br>
            México <br><br>
            <strong style="color: #0a680a;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">Télefono:</strong><br>
            357 388 0913 <br>
            <strong style="color: #0a680a;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;"> Correo:</strong> presidencia@casimirocastillo.gob.mx<br>




        </div>


        <div class="col-lg-3 col-md-6 footer-links">



          <h5 style="color: #0a680a;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">Transparencia Nacional</h5>
                    <a href="https://www.plataformadetransparencia.org.mx"> <img height="100" width="200" style="border-radius: 2vh;"
                        src="https://i.imgur.com/kYLT2N2.png" alt=""> </a>

                        <h5 style="color: #0a680a; margin-top: 2vh;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">Infomex Jalisco</h5>
                    <a
                      href="https://www.infomexjalisco.org.mx">
                      <img height="100" width="200" style="border-radius: 2vh; margin-left: .5vh; " src="https://i.imgur.com/YtJjpWC.png" alt=""> </a>




                  </div>


                  <div class="col-lg-2 col-md-6 footer-links">



                    <h5 style="color: #0a680a;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">Actas de Nacimiento</h5>
                              <a href="https://www.gob.mx/ActaNacimiento/"> <img height="100" width="200" style="border-radius: 2vh;"
                                  src="https://i.imgur.com/9IOztGS.png" alt=""> </a>

                                  <h5 style="color: #0a680a; margin-top: 2vh;font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">Curp</h5>
                              <a
                                href="https://www.gob.mx/curp/">
                                <img height="120" width="100" style=" margin-left: .5vh; " src="https://i.imgur.com/A4wGMwl.png" alt=""> </a>




                            </div>

                            <div class="col-lg-3 col-md-6 footer-links" style="margin-left: 5vh; margin-top: 5vh;">
                              <img style="width: 200px; height: 200px;" src="https://i.imgur.com/8I8IVje.png" alt="">

                             </div>

      </div>
    </div>
  </div>

  <div class="container d-md-flex py-4">

    <div class="me-md-auto text-center text-md-start">
      <div class="copyright" style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">
        &copy; CASIMIRO CASTILLO

       <strong><span style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', Times, serif;">  GOBIERNO MUNICIPAL 2024 - 2027</span></strong>   © Copyright casimirocastillo.gob.mx
      </div>

    </div>

  </div>








</footer><!-- End Footer -->
  <!-- <script async src="https://cdn.now4real.com/now4real.js"></script> -->
